export default "__VITE_ASSET__CCiYF7Cn__"